import { Checkbox } from '@alefeducation/ui-elements-library-core'
import React from 'react'
import { WithCommonType } from '../types'

export type CheckBoxTemplate = {
  isChecked: boolean
  label: string | JSX.Element
  value: string
}
type CheckboxProps = WithCommonType<CheckBoxTemplate>

const CheckboxTemplate = (props: CheckboxProps) => {
  const { isChecked, onChange, label, value, name, index } = props
  return (
    <div
      style={{
        display: 'flex'
      }}
    >
      <Checkbox
        variant="default"
        type="checkbox"
        data-testid={`${label}-${value}-checkbox-test-id`}
        checked={isChecked}
        onChange={e => onChange({ isChecked: e.target.checked, name, index, value, label })}
        value={value}
      >
        {label}
      </Checkbox>
    </div>
  )
}

export default CheckboxTemplate
